import { PlyrComponent } from 'plyr-react';
import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';

const VideoPresentation = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('videos')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    const longue = {
        type: 'video',
        sources: [
            {
                src: '431406067',
                provider: 'vimeo',
            },
        ]
    }

    const courte = {
        type: 'video',
        sources: [
            {
                src: '431405681',
                provider: 'vimeo',
            },
        ]
    }

    return (
        <div>
            <h1>Présentation brève de l'UV</h1>
            <p>Dans cette vidéo, le responsable présente l'UV rapidement. Il explique également les différents moyens par lesquels le joindre et son rôle dans l'UV.</p>
            <PlyrComponent sources={courte} />
            <br /><br />
            <h1>Présentation détaillée de l'UV</h1>
            <p>Dans cette vidéo, le responsable de l'UV se présente rapidement. Il vous présente aussi les différents moyens par lesquels le joindre et son rôle dans l'UV.</p>
            <PlyrComponent sources={longue} />
            <div className="button-container">
                <Button icon="arrow-left" to="?page=videos">Toutes les vidéos</Button>
                <Button icon="arrow-right" to="?page=videos&id=pix">Présentation de Pix</Button>
            </div>
        </div>
    );
}

export default VideoPresentation;